import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const PreviewHeader = styled(Typography, {
  name: 'PreviewHeader',
  slot: 'Root',
  skipSx: true,
})(
  `
    font-family: 'Source Sans Pro Semibold';
    font-size: '16px';
`,
)
